import type { TFunction } from "i18next";

export type AssignLevel = "stakeholder" | "topic" | "iro";

export const createMakePathLabel =
  (
    t: TFunction,
    selectedStakeholderTypes: Set<string>,
    selectedEsrs: Set<string>,
    getTopicLabel: (id: string) => string,
  ) =>
  (level: AssignLevel, currentLabel: string): string => {
    const stakeholderLabel = Array.from(selectedStakeholderTypes).join(", ") || "*";
    const topicLabel =
      Array.from(selectedEsrs).map(getTopicLabel).join(", ") || "*";

    if (level === "stakeholder") {
      return `${t("stakeholders.table.stakeholderType", "Stakeholder type")} - ${currentLabel}`;
    }

    if (level === "topic") {
      return `${t("stakeholders.table.stakeholderType", "Stakeholder type")} - ${stakeholderLabel} / ${t("stakeholders.table.esrsArea", "Topic")} - ${currentLabel}`;
    }

    return `${t("stakeholders.table.stakeholderType", "Stakeholder type")} - ${stakeholderLabel} / ${t("stakeholders.table.esrsArea", "Topic")} - ${topicLabel} / ${t("doubleMateriality.iro.title", "IRO")} - ${currentLabel}`;
  };
